import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChecklistPronounced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 3.5C0.447715 3.5 0 3.94772 0 4.5V11.5C0 12.0523 0.447715 12.5 1 12.5H8C8.55229 12.5 9 12.0523 9 11.5V4.5C9 3.94772 8.55229 3.5 8 3.5H1ZM7.6493 6.58449C7.92375 6.27424 7.89473 5.80025 7.58449 5.52581C7.27424 5.25136 6.80025 5.28038 6.52581 5.59062L3.84245 8.62398L2.80212 7.4924C2.52179 7.18747 2.04733 7.16754 1.7424 7.44788C1.43747 7.72821 1.41754 8.20267 1.69788 8.5076L3.30105 10.2514C3.44477 10.4077 3.64802 10.4958 3.86036 10.4938C4.0727 10.4917 4.27423 10.3998 4.41493 10.2407L7.6493 6.58449Z"
          fill={color}
        />
        <path opacity="0.6" d="M12 4L15.5 4" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M12 8H14.5" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M12 12H15.5" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default ChecklistPronounced
